import { ShaderMaterial, SmoothShading } from "three";

const fragmentShader = require("./shader.frag").default;
const vertexShader = require("./shader.vert").default;

class BubbleMaterial extends ShaderMaterial {
  constructor(options) {
    super({
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      shading: SmoothShading
    });

    this.uniforms = {
      time: { value: 0 },
      map: { value: options.map },
      mouse: { value: [0, 0] },
      refractMap: { value: options.refractMap }
    };
  }
}

export default BubbleMaterial;
